<template>
  <div>
    <div class="hidden-md-and-up box">
      <img src="../../static/main.svg" alt="">
    </div>
    <!-- テキストを入れたい -->
  </div>
</template>

<script>
export default {
  name: "HomeHeaderMdSize",
  computed: {
    isLogin: function () {
      return this.$store.getters["auth/isAuth"];
    },
  },
};
</script>

<style scoped>
.bg-static {
  background-image: url("../../static/main.svg");
}

@media screen and (max-width: 1264px) {
  img {
    width: 100%;
    object-fit: cover;
    object-position: 90% center;
    height: 100%;
  }
  .box {
    width: 100vw;
    height: 500px;
  }
}
@media screen and (max-width: 960px) {
  img {
    width: 100%;
    object-fit: cover;
    object-position: 90% center;
    height: 100%;
  }
  .box {
    width: 100vw;
    height: 500px;
  }
}
@media screen and (max-width: 600px) {
  img {
    width: 100%;
    object-fit: cover;
    object-position: 83% center;
    height: 100%;
  }
  .box {
    width: 100vw;
    height: 304px;
  }
}




</style>
